export default "__VITE_ASSET__b8778ee2__"